import { render, staticRenderFns } from "./AddMerchantForm.vue?vue&type=template&id=5f05ad25&"
import script from "./AddMerchantForm.vue?vue&type=script&lang=js&"
export * from "./AddMerchantForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports